<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card color="grey lighten-5">
        <v-card-title
          class="text-h5 primary white--text"
          v-text="`Excluir Processo de Inscrição`"
        />

        <!--Dados Do Aluno-->
        <v-card-text class="pt-6 font-weight-medium mb-2">
          Tem certeza de que quer excluir?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="$emit('cancel')">
            Não
          </v-btn>
          <v-btn color="blue darken-1" text @click="$emit('save')">
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "dialog_teste",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
